import { ImageNameEnum as e } from "../image-enum.mjs";
//#region src/extensions/image-extension/utils/is-image-selected.ts
var t = (t) => t ? t.isActive(e.Block) || t.isActive(e.Inline) : !1;
//#endregion
export { t as isImageSelected };
